import { ofType } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';

import {
    submitPerpayPlusSoloApplicationSuccess as submitPerpayPlusSoloApplicationSuccessAction,
    createPerpayPlusSoloFeatureEnrollmentSuccess,
} from '@perpay-web/fintech/actions/entities/perpayPlusSolo';
import {
    payrollPaymentSetupComplete,
    payrollPaymentSetupStart,
} from '@perpay-web/fintech/actions/payrollPaymentSetup';
import {
    OFFER_LOADER_STEP,
    SOFT_REJECTION,
    REVIEW_DIRECT_DEPOSIT_STEP,
    ACTIVATED_STEP,
    PAYROLL_PAYMENT_SETUP_STEP,
} from '@perpay-web/fintech/components/composite/PerpayPlusSoloApplication/PerpayPlusSoloApplicationSteps';
import { perpayPlusSoloApplicationSetSteps } from '@perpay-web/fintech/components/composite/PerpayPlusSoloApplication/usePerpayPlusSoloApplicationContext';
import { getUserUuid } from '@perpay-web/fintech/selectors/authentication';

export const perpayPlusSoloApplicationEpic = (action$, state$) =>
    action$.pipe(
        ofType(submitPerpayPlusSoloApplicationSuccessAction().type),
        withLatestFrom(state$),
        mergeMap(([action, state]) => {
            const userUuid = getUserUuid(state);

            localStorage.removeItem(`passed_solo_intro_steps_${userUuid}`);
            if (action.payload.result === 'failed') {
                return [perpayPlusSoloApplicationSetSteps(SOFT_REJECTION)];
            }
            localStorage.setItem(
                `passed_solo_application_step_${userUuid}`,
                true,
            );
            return [perpayPlusSoloApplicationSetSteps(OFFER_LOADER_STEP)];
        }),
    );

export const createPerpayPlusSoloFeatureEnrollmentSuccessEpic = (action$) =>
    action$.pipe(
        ofType(createPerpayPlusSoloFeatureEnrollmentSuccess().type),
        mergeMap(() => [
            perpayPlusSoloApplicationSetSteps(REVIEW_DIRECT_DEPOSIT_STEP),
        ]),
    );

export const perpayPlusSoloPayrollStart = (action$) =>
    action$.pipe(
        ofType(payrollPaymentSetupStart().type),
        mergeMap(() => [
            perpayPlusSoloApplicationSetSteps(PAYROLL_PAYMENT_SETUP_STEP),
        ]),
    );

export const perpayPlusSoloPayrollComplete = (action$) =>
    action$.pipe(
        ofType(payrollPaymentSetupComplete().type),
        mergeMap(() => [perpayPlusSoloApplicationSetSteps(ACTIVATED_STEP)]),
    );
